import { render } from "./AgendaListViewContainer.vue?vue&type=template&id=0595b431&scoped=true"
import script from "./AgendaListViewContainer.vue?vue&type=script&lang=js"
export * from "./AgendaListViewContainer.vue?vue&type=script&lang=js"

import "./AgendaListViewContainer.vue?vue&type=style&index=0&id=0595b431&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0595b431"]])

export default __exports__